import { render, staticRenderFns } from "./IframeReport.vue?vue&type=template&id=6a54df27&"
import script from "./IframeReport.vue?vue&type=script&lang=js&"
export * from "./IframeReport.vue?vue&type=script&lang=js&"
import style0 from "./IframeReport.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports